module.exports = __webpack_public_path__ + "img/shield-minus.c346ec00.svg";